export class Empleado {
    userId: number ;
    firstName: string ;
    secondName: string ;
    firstLastName: string ;
    secondLastName: string ;
    user:string;
    password: string ;
    token?: string;
    AgencyInformation:string;
    AgencyInformationId:string;
    ContactPerson:string;
    ContactPersonId:string;
    DateBirth:string;
    Email:string;
    OfficePhone:string;
    PersonalPhone:string;
    PostalAddress:string;
    PostalAddressId:string;
    ResidentialAddress:string;
    ResidentialAddressId:string;
    SecondLastName:string;
    SecondName:string;

    constructor(user) {
        this.userId = user.Id;
        this.firstName = (user.firstName ?  user.firstName : '');
        this.secondName = (user.secondName ?  user.secondName : '');
        this.firstLastName = (user.firstLastName ?  user.firstLastName : '');
        this.SecondLastName = (user.SecondLastName ?  user.SecondLastName : '');
        this.AgencyInformation = (user.AgencyInformation ?  user.AgencyInformation : '');
        this.AgencyInformationId = (user.AgencyInformationId ?  user.AgencyInformationId : '');
        this.ContactPerson = (user.ContactPerson ?  user.ContactPerson : '');
        this.ContactPersonId = (user.ContactPersonId ?  user.ContactPersonId : '');
        this.DateBirth = (user.DateBirth ?  user.DateBirth : '');
        this.Email = (user.Email ?  user.Email : '');
        this.OfficePhone = (user.OfficePhone ?  user.OfficePhone : '');
        this.PersonalPhone = (user.PersonalPhone ?  user.PersonalPhone : '');
        this.PostalAddress = (user.PostalAddress ?  user.PostalAddress : '');
        this.PostalAddressId = (user.PostalAddressId ?  user.PostalAddressId : '');
        this.ResidentialAddress = (user.ResidentialAddress ?  user.ResidentialAddress : '');
        this.ResidentialAddressId = (user.ResidentialAddressId ?  user.ResidentialAddressId : '');

    }
}
